import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import {
  ProofOfPerformanceReport,
  proofOfPerformanceReportSchema,
} from '@sophocles/entities/ProofOfPerformanceReport/proofOfPerformanceReportRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_PROOF_OF_PERFORMANCE_REPORTS = 'RECEIVE_PROOF_OF_PERFORMANCE_REPORTS';
function receiveProofOfPerformanceReports(json) {
  return {
    type: RECEIVE_PROOF_OF_PERFORMANCE_REPORTS,
    proofOfPerformanceReports: mapListToRecords(json, ProofOfPerformanceReport),
  };
}

/* Request Actions */
// starter request
export const REQUEST_PROOF_OF_PERFORMANCE_REPORT = 'REQUEST_PROOF_OF_PERFORMANCE_REPORT';
function requestProofOfPerformanceReports(proofOfPerformanceReport_id) {
  return {
    type: REQUEST_PROOF_OF_PERFORMANCE_REPORT,
    proofOfPerformanceReport_id,
  };
}

export const REQUEST_SITE_PROOF_OF_PERFORMANCE_REPORT = 'REQUEST_SITE_PROOF_OF_PERFORMANCE_REPORT';
function requestSiteProofOfPerformanceReports(site_id) {
  return {
    type: REQUEST_SITE_PROOF_OF_PERFORMANCE_REPORT,
    site_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchProofOfPerformanceReport(proofOfPerformanceReport_id) {
  return dispatch => {
    dispatch(requestProofOfPerformanceReports(proofOfPerformanceReport_id));
    return apiClient
      .get(`/proofofperformancereports/${proofOfPerformanceReport_id}/`)
      .then(response => normalizeList(response.data, 'proofOfPerformanceReports', proofOfPerformanceReportSchema))
      .then(json => dispatch(receiveProofOfPerformanceReports(json.entities.proofOfPerformanceReports)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_PROOF_OF_PERFORMANCE_REPORT));
      });
  };
}

export function fetchProofOfPerformanceReportsForSiteWithRange(site_id, from, to) {
  return dispatch => {
    dispatch(requestSiteProofOfPerformanceReports());
    return apiClient
      .get('/proofofperformancereports/', {
        params: {
          limit: 10000,
          site: site_id,
          report_date__gte: from,
          report_date__lte: to,
        },
      })
      .then(response =>
        normalizeList(response.data.results, 'proofOfPerformanceReports', proofOfPerformanceReportSchema),
      )
      .then(json => dispatch(receiveProofOfPerformanceReports(json.entities.proofOfPerformanceReports)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_SITE_PROOF_OF_PERFORMANCE_REPORT));
      });
  };
}

/* Edit Actions */
export const EDIT_PROOF_OF_PERFORMANCE_REPORT = 'EDIT_PROOF_OF_PERFORMANCE_REPORT';
export function editProofOfPerformanceReport(proofOfPerformanceReport_id) {
  return {
    type: EDIT_PROOF_OF_PERFORMANCE_REPORT,
    proofOfPerformanceReport: proofOfPerformanceReport_id,
  };
}

export function patchProofOfPerformanceReport(proofOfPerformanceReport_id, values) {
  return dispatch => {
    dispatch(editProofOfPerformanceReport(proofOfPerformanceReport_id));
    return apiClient
      .patch(`/proofofperformancereports/${proofOfPerformanceReport_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, proofOfPerformanceReportSchema))
      .then(json => {
        dispatch(receiveProofOfPerformanceReports(json.entities.proofOfPerformanceReports));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, EDIT_PROOF_OF_PERFORMANCE_REPORT));
      });
  };
}

/* Create Actions */
export const CREATE_PROOF_OF_PERFORMANCE_REPORT = 'CREATE_PROOF_OF_PERFORMANCE_REPORT';
function sayCreateProofOfPerformanceReport(values) {
  return {
    type: CREATE_PROOF_OF_PERFORMANCE_REPORT,
    values: values,
  };
}

export function createProofOfPerformanceReport(values) {
  return dispatch => {
    dispatch(sayCreateProofOfPerformanceReport(values));
    return apiClient
      .post(`/proofofperformancereports/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, proofOfPerformanceReportSchema))
      .then(json => {
        dispatch(receiveProofOfPerformanceReports(json.entities.proofOfPerformanceReports));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, CREATE_PROOF_OF_PERFORMANCE_REPORT));
      });
  };
}

/* Delete Actions */
export const DELETE_PROOF_OF_PERFORMANCE_REPORT = 'DELETE_PROOF_OF_PERFORMANCE_REPORT';
function sayDeleteProofOfPerformanceReport(proofOfPerformanceReport_id) {
  return {
    type: DELETE_PROOF_OF_PERFORMANCE_REPORT,
    proofOfPerformanceReport: proofOfPerformanceReport_id,
  };
}

export function deleteProofOfPerformanceReport(proofOfPerformanceReport_id) {
  return dispatch =>
    apiClient
      .delete(`/proofofperformancereports/${proofOfPerformanceReport_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteProofOfPerformanceReport(proofOfPerformanceReport_id)))
      .catch(error => {
        dispatch(genericErrorAction(error, DELETE_PROOF_OF_PERFORMANCE_REPORT));
      });
}
